interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "Icon" code-brackets asset from the Share-your-Model Figma frame (74150:2725). */
const FigmaEmbedIcon = ({ width = 16, height = 16, color = '#8B5CF6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.6667 12L14.6667 8L10.6667 4'
        stroke={color}
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.33333 4L1.33333 8L5.33333 12'
        stroke={color}
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default FigmaEmbedIcon;
